// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ListItemIcon":"bcx_a bih_ke","ListItemIcon--empty":"bcx_b bih_fl"};